/* eslint-disable */
/* auto-generated file. do not edit manually. */

export const Assets = {
  branding: {
    logoPng: 'assets/branding/logo.png'
  },
  icons: {
    accountCircleSvg: 'assets/icons/account-circle.svg',
    arrowRightSvg: 'assets/icons/arrow-right.svg',
    binSvg: 'assets/icons/bin.svg',
    cameraSvg: 'assets/icons/camera.svg',
    cartOffSvg: 'assets/icons/cart-off.svg',
    cartOutlineSvg: 'assets/icons/cart-outline.svg',
    cartPlusSvg: 'assets/icons/cart-plus.svg',
    cartSvg: 'assets/icons/cart.svg',
    checkCircleSvg: 'assets/icons/check-circle.svg',
    chevronDownSvg: 'assets/icons/chevron-down.svg',
    chevronLeftSvg: 'assets/icons/chevron-left.svg',
    chevronRightSvg: 'assets/icons/chevron-right.svg',
    closeSvg: 'assets/icons/close.svg',
    dashboardSvg: 'assets/icons/dashboard.svg',
    dragSvg: 'assets/icons/drag.svg',
    editSvg: 'assets/icons/edit.svg',
    emailFilledSvg: 'assets/icons/email-filled.svg',
    emailOutlineSvg: 'assets/icons/email-outline.svg',
    emailSvg: 'assets/icons/email.svg',
    eyeSvg: 'assets/icons/eye.svg',
    facebookSvg: 'assets/icons/facebook.svg',
    fireworkSvg: 'assets/icons/firework.svg',
    gearSvg: 'assets/icons/gear.svg',
    hamburgerSvg: 'assets/icons/hamburger.svg',
    infoSvg: 'assets/icons/info.svg',
    instagramSvg: 'assets/icons/instagram.svg',
    leftArrowSvg: 'assets/icons/left-arrow.svg',
    logoSvg: 'assets/icons/logo.svg',
    logoutSvg: 'assets/icons/logout.svg',
    magnifySvg: 'assets/icons/magnify.svg',
    mapMarkerOutlineSvg: 'assets/icons/map-marker-outline.svg',
    mapSvg: 'assets/icons/map.svg',
    minusSvg: 'assets/icons/minus.svg',
    phoneOutlineSvg: 'assets/icons/phone-outline.svg',
    phoneSvg: 'assets/icons/phone.svg',
    plusSvg: 'assets/icons/plus.svg',
    productSvg: 'assets/icons/product.svg',
    refreshSvg: 'assets/icons/refresh.svg',
    rightArrowSvg: 'assets/icons/right-arrow.svg',
    searchSvg: 'assets/icons/search.svg',
    shoppingBagSvg: 'assets/icons/shopping-bag.svg',
    squareEditOutlineSvg: 'assets/icons/square-edit-outline.svg',
    tagSvg: 'assets/icons/tag.svg',
    trashSvg: 'assets/icons/trash.svg',
    userSvg: 'assets/icons/user.svg',
    youtubeSvg: 'assets/icons/youtube.svg'
  },
  images: {
    annaiLogoPng: 'assets/images/annai-logo.png',
    ayyansLogoPng: 'assets/images/ayyans-logo.png',
    blueStarLogoPng: 'assets/images/blue-star-logo.png',
    crackersJpg: 'assets/images/crackers.jpg',
    hero1280Jpg: 'assets/images/hero-1280.jpg',
    hero1280Webp: 'assets/images/hero-1280.webp',
    hero800Jpg: 'assets/images/hero-800.jpg',
    hero800Webp: 'assets/images/hero-800.webp',
    heroJpg: 'assets/images/hero.jpg',
    homeMarketingJpg: 'assets/images/home-marketing.jpg',
    homeMarketingWebp: 'assets/images/home-marketing.webp',
    productPlaceholderPng: 'assets/images/product-placeholder.png',
    sonyPng: 'assets/images/sony.png',
    wowStarJpg: 'assets/images/wow-star.jpg',
    yuvrajLogoPng: 'assets/images/yuvraj-logo.png'
  }
} as const;

export type AssetsType = typeof Assets;
